import { css } from 'styled-components';
import { getColorFromVar } from '../variables/colors';

export const getColor = (key: string, level?: number) =>
  css`
    ${(p) => getColorFromVar(p.theme, key, level)}
  `;
